
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.848 14.616a.625.625 0 01.884 0l2.652 2.651a.625.625 0 11-.884.884L21.848 15.5a.625.625 0 010-.883z"}}),_c('path',{attrs:{"d":"M26.384 15.384a1.25 1.25 0 10-1.769-1.768l-8.809 8.809-.294 2.063 2.062-.295 8.81-8.809zm-8.426 10.017l-3.094.442a.625.625 0 01-.708-.707l.442-3.094a.625.625 0 01.177-.354l8.956-8.956a2.5 2.5 0 013.536 3.536l-8.956 8.956a.626.626 0 01-.353.177z"}})])
          )
        }
      }
    